import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { apiZodios } from '~api/apiZodios'
import { OrganizationAISettings0 } from '~types'

import QueryView from './QueryView'

const QueryEmbedScreen: React.FC = () => {
  const [searchParams] = useSearchParams()
  const { organizationHandle } = useParams<{ organizationHandle: string }>()
  const isEmbedded = searchParams.has('embed')
  const isIframe = searchParams.has('iframe')
  const testing = searchParams.has('testing')
  const initialQuery = searchParams.get('query') || ''
  const [organizationSettings, setOrganizationSettings] = useState<OrganizationAISettings0>()
  const [suggestions, setSuggestions] = useState<string[]>([])

  const initializeAI = async (): Promise<void> => {
    try {
      const response = await apiZodios.ai_initializeAI({
        organization_handle: organizationHandle,
      })
      setOrganizationSettings(response.organization)

      const texts = response.suggestions.map((suggestion) => suggestion.text)
      if (texts.length == 0) {
        const sugg =
          response.organization.organization_type === 'OrganizationCity'
            ? 'Ask a question (e.g. "Where is city hall?")'
            : response.organization.organization_type === 'OrganizationCounty'
              ? 'Ask a question (e.g. "Where is the county administration building?")'
              : 'Ask a question'

        const fallBackSuggs = [
          sugg,
          'How do I get a building permit?',
          `Why should I live in ${response.organization.organization.name}?`,
          'When is my trash picked up?',
        ]
        setSuggestions(fallBackSuggs)
      } else {
        setSuggestions(texts)
      }
    } catch (error) {
      console.error('Error initializing AI:', error)
    }
  }

  useEffect(() => {
    initializeAI()
  }, [organizationHandle])

  if (!organizationSettings) {
    return null
  }

  if (isIframe) {
    const currentUrl = window.location.href
    const embedUrl = currentUrl.replace('iframe', 'embed')

    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '768px',
          }}
        >
          <iframe
            title='polimorphic-search'
            aria-label='Polimorphic Search'
            src={embedUrl}
            style={{
              width: '100%',
              height: '600px',
              border: 'none',
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <QueryView
      orgSettings={organizationSettings}
      suggestions={suggestions}
      isEmbedded={isEmbedded}
      testing={testing}
      initialQuery={initialQuery}
    />
  )
}

export default QueryEmbedScreen
